import { all, call, put, takeLeading } from 'redux-saga/effects';
import { loadEmployeeHours } from 'store/glue/operation/loadEmployeeHours';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';

import * as flexHoursActions from './actions';
import * as constants from './constants';

// When the user picks dates from the calendar modal, persist the selection
// to flexHours state and fan out a fetch for employee-hour rows at the
// chosen dates. The fetch goes through `loadEmployeeHours` which handles
// tenant + feature guards and toasts any terminal failure — the saga itself
// only needs to fire the dispatch and forward the dates.
function* startSelectDatesSaga(
  action: ActionType<typeof flexHoursActions.startSelectDates>,
) {
  function* saga() {
    const { selectedDates } = action.payload;
    yield put(flexHoursActions.setSelectedDates(selectedDates));
    yield call(loadEmployeeHours, { dates: selectedDates });
  }

  yield call(sagaWrapper, { saga, type: action.type });
}

export function* watcher() {
  yield all([takeLeading(constants.START_SELECT_DATES, startSelectDatesSaga)]);
}
